import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { Box } from '@mui/material';
import { ApexOptions } from 'apexcharts';
import { useTheme } from '@mui/material/styles';

interface PieChartProps {
  data: {
    series: number[];
    labels: string[];
  };
}

const PieChart: React.FC<PieChartProps> = ({ data }) => {
  const theme = useTheme();

  const options: ApexOptions = {
    chart: {
      type: 'pie',
      background: 'transparent',
      animations: {
        enabled: true,
      },
    },
    labels: data.labels,
    colors: [
      '#003f5c',
      '#374c80',
      '#7a5195',
      '#bc5090',
      '#ef5675',
      '#ff764a',
      '#ffa600',
    ],
    legend: {
      position: 'bottom',
      horizontalAlign: 'center',
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
    dataLabels: {
      enabled: true,
      formatter: (val: number) => `${val.toFixed(1)}%`,
    },
    tooltip: {
      enabled: true,
      theme: 'dark',
      style: {
        fontSize: '12px',
      },
      y: {
        formatter: (val: number) => `${val.toFixed(2)} hours`,
      },
    },
  };

  return (
    <Box sx={{ width: '100%', height: '100%' }}>
      <ReactApexChart
        options={options}
        series={data.series}
        type="pie"
        height={300}
      />
    </Box>
  );
};

export default PieChart;
